export enum PreparePermitStep {
    PrefixAndWorkCode = 0,
    FixedTemplate = 1,
    CustomerCheckpoint = 2,
    PermitPhoto = 3
}
